import React from 'react';
import { AlertCircle } from 'lucide-react';

/**
 * ValidatedSelect - Reusable select component with validation error display
 */
const ValidatedSelect = ({
  name,
  label,
  register,
  errors,
  options = [],
  placeholder = 'Select an option',
  icon: Icon,
  className = '',
  required = false,
  disabled = false,
  ...rest
}) => {
  const hasError = errors && errors[name];
  const errorMessage = hasError ? errors[name].message : null;

  return (
    <div className={`validated-input-wrapper ${className}`}>
      {label && (
        <label 
          htmlFor={name} 
          className="validated-input-label"
        >
          {label}
          {required && <span className="required-indicator"> *</span>}
        </label>
      )}
      
      <div className="validated-input-container">
        {Icon && (
          <div className="input-icon-wrapper">
            <Icon className="input-icon" />
          </div>
        )}
        
        <select
          id={name}
          {...register(name)}
          disabled={disabled}
          className={`validated-select ${hasError ? 'input-error' : ''} ${Icon ? 'input-with-icon' : ''}`}
          aria-invalid={hasError ? 'true' : 'false'}
          aria-describedby={hasError ? `${name}-error` : undefined}
          {...rest}
        >
          <option value="">{placeholder}</option>
          {options.map((option) => {
            if (typeof option === 'string') {
              return (
                <option key={option} value={option}>
                  {option}
                </option>
              );
            }
            return (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            );
          })}
        </select>
      </div>

      {hasError && (
        <div 
          id={`${name}-error`}
          className="validation-error"
          role="alert"
        >
          <AlertCircle className="error-icon" />
          <span className="error-message">{errorMessage}</span>
        </div>
      )}
    </div>
  );
};

export default ValidatedSelect;

